import React from "react";
import { CheckCircle2, AlertTriangle, X, Eye } from "lucide-react";

export function PreCheckModal({ report, onCancel, onContinue }) {
  const { items = [], warnings = [], blocking = [], can_publish } = report || {};
  return (
    <div className="fixed inset-0 z-[60] grid place-items-center bg-slate-900/50 backdrop-blur-sm p-4" data-testid="pre-publish-modal">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-5 sm:p-6">
        <div className="flex items-start gap-2">
          <div className="h-9 w-9 rounded-xl bg-[#FBF4DF] text-[#8a6d14] grid place-items-center">
            <CheckCircle2 size={18}/>
          </div>
          <div className="flex-1">
            <h3 className="text-base font-extrabold text-[#0A2540]" style={{ fontFamily: "Poppins" }}>Ready to publish?</h3>
            <p className="text-xs text-slate-500">Missing sections won&apos;t block you — but the client will see whatever you publish.</p>
          </div>
          <button onClick={onCancel} className="text-slate-400 hover:text-[#0A2540]"><X size={16}/></button>
        </div>
        <ul className="mt-4 space-y-1.5">
          {items.map((i) => (
            <li key={i.key} className="flex items-center gap-2 text-sm" data-testid={`precheck-${i.key}`}>
              {i.ok ? (
                <CheckCircle2 size={14} className="text-emerald-500 shrink-0"/>
              ) : i.required ? (
                <AlertTriangle size={14} className="text-rose-500 shrink-0"/>
              ) : (
                <AlertTriangle size={14} className="text-amber-500 shrink-0"/>
              )}
              <span className={`flex-1 ${i.ok ? "text-slate-700" : (i.required ? "text-rose-600 font-semibold" : "text-slate-500")}`}>
                {i.label}
                {i.required && !i.ok && <span className="ml-1 text-[10px] font-bold uppercase text-rose-500">required</span>}
              </span>
            </li>
          ))}
        </ul>
        {blocking.length > 0 && (
          <div className="mt-4 text-xs text-rose-600 bg-rose-50 border border-rose-200 rounded-xl p-3">
            Fill the required section{blocking.length > 1 ? "s" : ""} above before publishing.
          </div>
        )}
        {warnings.length > 0 && blocking.length === 0 && (
          <div className="mt-4 text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-xl p-3">
            {warnings.length} section{warnings.length > 1 ? "s are" : " is"} empty. Continue if you meant to keep the record short.
          </div>
        )}
        <div className="mt-5 flex justify-end gap-2">
          <button onClick={onCancel} className="px-4 py-2 text-xs font-bold rounded-full border border-slate-200 hover:bg-slate-50" data-testid="precheck-cancel">
            Keep editing
          </button>
          <button
            onClick={onContinue}
            disabled={!can_publish}
            className="px-4 py-2 text-xs font-bold rounded-full bg-[#0A2540] text-[#D4AF37] hover:opacity-90 disabled:opacity-50 inline-flex items-center gap-1"
            data-testid="precheck-continue-preview"
          >
            <Eye size={13}/> Continue to Preview
          </button>
        </div>
      </div>
    </div>
  );
}
